import * as yup from 'yup';

export const SpotSchema = yup.object().shape({
  name: yup.string().trim().required('スポット名を入力してください'),
});
